import PropTypes from 'prop-types';
import Icon from '../Icon';
import {
	PRODUCT_SELECTION_GUIDE_CLICK_EVENT,
	SIMULATION_FILE_DOWNLOAD_CLICK_EVENT,
} from '../../config/analytics.telemetry';
import { sendUserInteractionsToTelemetryFor } from '../../utility/analytics.telemetry';
import './style.css';
import {
	TYPE_DOWNLOAD_FILE,
	TYPE_OPEN_IN_NEW_TAB_SMALL,
	TYPE_PDF_DOCUMENT,
	TYPE_SPANNER_TOOL,
} from '../../config/icon-types';

/**
 * Renders an Additional Resource (simulation files, product selection guide etc.)
 * @param {*} props Props passed to this component
 * @returns {React.ReactComponentElement} Additional Resource Component
 */
const AdditionalResource = props => {
	const classes = ['adi-isp__additional-resource'];
	const { solutionId, resource } = props;

	const { type, title, description, url } = resource;
	const shouldDownload = type === 'downloadFile';
	const fileCategoryName = shouldDownload ? 'LTSPICE' : 'PDF';
	const fileCategoryIcon = shouldDownload ? TYPE_SPANNER_TOOL : TYPE_PDF_DOCUMENT;
	const fileType = shouldDownload ? TYPE_DOWNLOAD_FILE : TYPE_OPEN_IN_NEW_TAB_SMALL;

	/**
	 * Makes telemetry call for 'simulation_file_download_click' or 'product_selection_guide_click'
	 */
	const onFileLinkClick = () => {
		const eventName = shouldDownload
			? SIMULATION_FILE_DOWNLOAD_CLICK_EVENT
			: PRODUCT_SELECTION_GUIDE_CLICK_EVENT;

		sendUserInteractionsToTelemetryFor(eventName, { url }, solutionId);
	};

	return (
		<article className={classes.join(' ')}>
			<header className={`${classes[0]}-title`}>{title}</header>

			<section className={`${classes[0]}-file-category`}>
				<Icon className={`${classes[0]}-icon`} type={fileCategoryIcon} />
				<span>{fileCategoryName}</span>
			</section>

			<section className={`${classes[0]}-details`}>
				<a
					className={`${classes[0]}-file-link`}
					href={url}
					target={shouldDownload ? null : '_blank'}
					rel={shouldDownload ? null : 'noopener noreferrer'}
					download={shouldDownload}
					onClick={onFileLinkClick}
				>
					{description}
					<Icon className={`${classes[0]}-icon`} type={fileType} />
				</a>
			</section>
		</article>
	);
};

AdditionalResource.propTypes = {
	solutionId: PropTypes.string.isRequired,
	resource: PropTypes.object.isRequired,
};

export default AdditionalResource;
